import { type ApiClientResponse, apiClient, routes } from 'common/services';
import type { InterestDataObject } from 'models/service';

export const getInterests = async () =>
  apiClient.get<InterestDataObject[], ApiClientResponse<InterestDataObject[]>>(routes.user.interets);
